export enum VehicleTabViewVariant {
  DETAILS = "details",
  FEATURES = "features",
  PRICING = "pricing",
  BOOKING_TOOL_SETTINGS = "booking-tool-settings",
}
